import styled from 'styled-components';

// Components
import AddressInput from 'top-component-library/Fields/AddressInput';

// Constants
import breakpoints from 'constants/breakpoints';
import { button } from 'constants/style';

export const StyledAddressInput = styled(AddressInput)`
  height: ${button.small}px;

  input {
    font-size: 0.75rem;
    padding: 0 0.875rem;

    &::placeholder {
      color: var(--color-neutral__placeholder);
      font-size: 0.75rem;

      @media (min-width: ${breakpoints.md}px) {
        font-size: 0.875rem;
        font-weight: 500;
        letter-spacing: 0.5px;
      }
    }
  }
`;
